<template>
  <v-card height="600">
    <v-toolbar flat>
      <v-btn
        fab
        text
        small
        color="grey darken-2"
        @click="prev"
      >
        <v-icon small>
          mdi-chevron-left
        </v-icon>
      </v-btn>
      <v-btn
        fab
        text
        small
        color="grey darken-2"
        @click="next"
      >
        <v-icon small>
          mdi-chevron-right
        </v-icon>
      </v-btn>
      <v-toolbar-title v-if="ready">
        {{ $refs.calendar.title }}
      </v-toolbar-title>
    </v-toolbar>
    <v-calendar
      ref="calendar"
      v-model="focus"
      @click:event="getDates"
      :events="avaiableDates"
      :now="today"
      :value="today"
      color="primary"
    >

    </v-calendar>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        class='gsfBtn'
        text
        @click='$emit("back")'
      >
        <v-icon
          right
          dark
        >
          mdi-chevron-left
        </v-icon>
        Back
      </v-btn>

    </v-card-actions>
  </v-card>

</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields(["avaiableDates", "selectedMonth", "selectedDate"]),
  },
  data() {
    return {
      ready: false,
      loading: false,
      focus: "",
      today: this.$moment().format("yyyy-MM-DD"),
    };
  },
  mounted() {
    this.$emit("nextMonth");
    this.ready = true;
  },
  methods: {
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
      this.selectedMonth = this.$moment(
        this.$moment(this.$refs.calendar.title).add(-1, "M").format("yyyy-MM")
      );
      this.$emit("lastMonth");
    },
    next() {
      this.$refs.calendar.next();
      this.selectedMonth = this.$moment(this.$refs.calendar.title)
        .add(1, "M")
        .format("yyyy-MM");
      this.$emit("nextMonth");
    },
    getDates(item) {
      this.selectedDate = item.day.date;
      this.$emit("loadTime");
    },
  },
};
</script>

<style >
</style>